module.exports = __webpack_public_path__ + "static/media/GERMANY.5c9661f6.svg";